<template>
  <ClientOnly>
    <UColorModeButton
      color="neutral"
      variant="ghost"
      size="sm"
    />
    <template #fallback>
      <UButton
        color="neutral"
        variant="ghost"
        size="sm"
        icon="i-lucide-sun"
        square
        disabled
      />
    </template>
  </ClientOnly>
</template>
